@if (optionGroup$) {
  <motn-popover-multi-select
    [multiOrSingle]="multiOrSingle"
    [optionGroup$]="optionGroup$"
    [loading]="loading"
    [inputPlaceholder]="'App Name or ID'"
    (clickedOutsideMenu$)="clickedOutsideMenu$.emit()"
    (clickedOption$)="onSelectApp($event)"
    [overlayPositions]="overlayPositions"
  ></motn-popover-multi-select>
}
